import { ITag } from "@app/interfaces/ITag";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IVeriListRow } from "@directives/_veri/veriList/veriList.component";
import { IGeofence } from "@interfaces/IGeofences";
import { GeofenceService } from "@services/geofence.service";
import { TagsService } from "@services/tags.service";
import * as angular from "angular";
import "./geofenceTags.scss";

interface IGeofenceTagsBindings {
    geofence: IGeofence;
    tags: ITag[];
}

class GeofenceTagsComponentController implements angular.IComponentController, IGeofenceTagsBindings {

    geofence: IGeofence;
    geofences: IGeofence[];
    tags: ITag[] = [];

    includedRows: IVeriListRow<ITag>[] = [];
    excludedRows: IVeriListRow<ITag>[] = [];

    listExcluded: ITag[] = [];
    allTags: ITag[] = [];
    veriMap: IVeriMapComponent;

    onIncludedListChanged: (args: { list: ITag[] }) => void;

    static $inject = ["tagsService", "geofenceService"];

    constructor(
        private readonly tagsService: TagsService,
        private readonly geofenceService: GeofenceService
    ) {

    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        if (onChangesObj["geofence"] || onChangesObj["tags"]) {
            this.initialise();
            this.mapLoaded(this.veriMap);
        }
    }

    addAllItemsToList() {
        this.geofence.Tags = angular.copy(this.allTags);
        this.listExcluded = [];

        this.updateAllRows();
    }

    addItemToList(tag: ITag) {
        this.geofence.Tags.push(tag);

        const index = this.listExcluded.indexOf(tag);
        if (index >= 0) {
            this.listExcluded.splice(index, 1);
        }

        this.updateAllRows();
    }

    mapLoaded(veriMap: IVeriMapComponent) {
        this.veriMap = veriMap;
        this.geofenceService.fitMapToGeofences(veriMap, this.geofence, this.geofences);
    }

    mapUnloaded() {
        this.veriMap = null;
    }

    removeAllItemsFromList() {
        this.geofence.Tags = [];
        this.listExcluded = angular.copy(this.allTags);

        this.updateAllRows();
    }

    removeItemFromList(tag: ITag) {
        this.listExcluded.push(tag);

        const index = this.geofence.Tags.indexOf(tag);
        if (index >= 0) {
            this.geofence.Tags.splice(index, 1);
        }

        this.updateAllRows();
    }

    private createExcludedRows() {
        this.excludedRows = [];

        if (!this.listExcluded) {
            return;
        }

        this.listExcluded.forEach(tag => {
            this.excludedRows.push({
                contents: tag.Name,
                data: tag,
                sortData: tag.Position
            });
        });
    }

    private createIncludedRows() {
        this.includedRows = [];

        if (!this.geofence.Tags) {
            return;
        }

        this.geofence.Tags.forEach(tag => {
            this.includedRows.push({
                contents: tag.Name,
                data: tag,
                sortData: tag.Position
            });
        });
    }

    private createExcludedList() {
        this.listExcluded = [];

        if (!this.allTags) {
            console.error("list-all parameter not provided");
            return;
        }

        if (!this.geofence.Tags) {
            console.error("list-included parameter not provided");
            return;
        }

        this.allTags.forEach(item => {
            var found = false;
            this.geofence.Tags.forEach(item2 => {
                if (item.Id === item2.Id) {
                    found = true;
                }
            });

            if (!found) {
                this.listExcluded.push(item);
            }
        });
    }

    private initialise() {
        this.geofenceService.getGeofences().then(geofences => {
            this.geofences = geofences;
        })

        if (!this.geofence.Tags) {
            this.geofence.Tags = [];
        }

        if (this.tags && this.tags.length > 0) {
            this.allTags = this.tags;
            this.updateTables();
        } else {
            this.tagsService.getTags().then(tags => {
                this.allTags = tags;

                this.updateTables();
            });
        }
    }

    private sortTagsInToPriorityOrder(tags: ITag[]) {
        tags.sort((t1, t2) => {
            return t1.Position < t2.Position ? -1 : 1;
        });
    }

    private updateGeofencePrimaryTag() {
        if (this.geofence.Tags.length > 0) {
            this.sortTagsInToPriorityOrder(this.geofence.Tags);
            this.geofence.PriorityTag = this.geofence.Tags[0];
        } else {
            this.geofence.PriorityTag = null;
        }
    }

    private updateTables() {
        this.createExcludedList();
        this.updateAllRows(true);
    }

    private updateAllRows(blockCallback = false) {

        this.sortTagsInToPriorityOrder(this.listExcluded);
        this.sortTagsInToPriorityOrder(this.geofence.Tags);
        this.geofence.TagIds = [];
        this.geofence.Tags.forEach(tag => {
            this.geofence.TagIds.push(tag.Id);
        });
        this.updateGeofencePrimaryTag();

        this.createIncludedRows();
        this.createExcludedRows();

        if (this.onIncludedListChanged && !blockCallback) {

            this.onIncludedListChanged({ list: this.geofence.Tags });
        }
    }
}

export class GeofenceTagsComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            geofence: "<",
            tags: "<",

            onIncludedListChanged: "&",
        };

        this.controller = GeofenceTagsComponentController;
        this.template = require("./geofenceTags.html");
    }
}
